<template>
  <div class="input-group input-group-outline input-add" :class="{'my-input-disabled': isBlocked === true }">
    <input type="text" :value="named" ref="namedInput" class="form-control" @focus="selectContent"
      @input="handleInput" />
  </div>
</template>

<script>
export default {
  props: {
    named: { type: String, default: "" },
    id: { type: String, required: false, default: "" },
    userAdmin: { type: [Number, String], required: false }
  },
  data() {
    return {
      debouncedSetValue: null
    };
  },
  computed: {
    isBlocked() {
      if (this.userAdmin != null && this.userAdmin != 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    selectContent() {
      this.$refs.namedInput.select();
    },
    handleInput(event) {
      this.debouncedSetValue(event.target.value);
    },
    setValue(value) {
      this.$emit("input", value, this.id);
    },
    debounce(func, wait) {
      let timeout;

      return function (...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }
  },
  created() {
    // Cria uma versão debounced do método setValue
    this.debouncedSetValue = this.debounce(this.setValue, 1000);
  }
};
</script>

<style scoped>
input.form-control {
  border: none !important;
  font-size: 22px !important;
  padding-left: 0px !important;
}
.my-input-disabled{
  background: none !important;
}
</style>